import { RenderOptions, TemplateResult, render } from "lit-html";

export interface RenderTemplateOptions {
  litRenderOptions?: RenderOptions;
  clearSSRContent?: boolean;
}

export const renderTemplate = (
  content: TemplateResult | TemplateResult[],
  target: HTMLElement | ShadowRoot | DocumentFragment,
  options?: RenderTemplateOptions,
) => {
  const { litRenderOptions, clearSSRContent = false } = options || {};
  // @ts-ignore
  if (clearSSRContent === true && target._hdeContentCleared !== true) {
    target.replaceChildren();
    // @ts-ignore
    target._hdeContentCleared = true;
  }
  render(content, target, litRenderOptions);
};
